import { render, staticRenderFns } from "./EmailAgend.vue?vue&type=template&id=8ad41450"
import script from "./EmailAgend.vue?vue&type=script&lang=ts"
export * from "./EmailAgend.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports